import React, { createContext, useContext } from 'react';
const ContainerContext = createContext(undefined);
export const ContainerProvider = ({ size, direction = 'vertical', children, }) => {
    const { size: parentSize } = useContainer();
    return (React.createElement(ContainerContext.Provider, { value: {
            size: size || parentSize,
            direction,
        } }, children));
};
export const useContainer = () => {
    const context = useContext(ContainerContext);
    if (context === undefined) {
        return {
            size: 'full',
            direction: 'vertical',
        };
    }
    return context;
};
//# sourceMappingURL=ContainerContext.js.map